



















































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component
export default class AddLanguageKeyForm extends Mixins(InputFieldMethods) {
    public key: string = '';
    public prefix: string = '';

    constructor() {
        super();
    }

    public addLanguage() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.ADD_LANGUAGE_NEW_KEY, {
                    key: this.key,
                    prefix: this.prefix,
                });
            }
        });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_LANGUAGE_KEY_VISIBILITY, false);
    }
}
